import React, { useState } from 'react';
import * as env from 'config/environment';
import * as consts from 'config/consts';
import {
  syncAccountAsset,
  GetUserBrokerResultItem,
  prepareUserBroker,
} from 'config/api';
import { useRouting } from 'hooks/useRouting';
import Modal2 from 'components/commons/modal/Modal2';
import Loading from 'components/commons/loading/Loading';
import Icon from 'components/commons/icon/Icon';
import {
  SyncAccountAssetResponseProps,
  getSyncAccountAssetResultCodeMessage,
  getSyncAccountAssetResultCodeTitle,
} from './AccountUpdateStoppedModal';
import GoMoneytreeSiteDialog from '../MoveMoneytreeSiteDialog';
import { convertToMonoBrokerId } from '../utils/converter';

type BrokerListProps = {
  id: string;
  name: string;
  url: string;
  link: string;
};

const PhoneNumberVerificationBrokerModalInternal = ({
  brokerID,
  account,
  redirectPath,
  isShow,
  isLoading,
  setIsLoading,
  hide,
  doChange,
}: {
  brokerID: string;
  account: string;
  redirectPath: string;
  isShow: boolean;
  isLoading: boolean;
  setIsLoading: (e: boolean) => void;
  hide: () => void;
  doChange: () => void;
}) => {
  const [isShowSecondStep, setIsShowSecondStep] = useState<boolean>(false);
  const [syncAccountAssetResponse, setSyncAccountAssetResponse] = useState<
    SyncAccountAssetResponseProps
  >({ tag: 'NotUpdated' });

  const brokerList = [
    {
      id: consts.MONOBrokerIds.SBI証券,
      name: 'SBI証券',
      url: 'https://www.sbisec.co.jp/ETGate/',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47438392953753-SBI%E8%A8%BC%E5%88%B8%E3%81%AE%E5%A4%9A%E8%A6%81%E7%B4%A0%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.楽天証券,
      name: '楽天証券',
      url: 'https://www.rakuten-sec.co.jp/ITS/V_ACT_Login.html',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.松井証券,
      name: '松井証券',
      url: 'https://www.matsui.co.jp/?mnu=hd',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.三菱UFJeスマート証券,
      name: '三菱UFJ eスマート証券',
      url: 'https://kabu.com/',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.マネックス証券,
      name: 'マネックス証券',
      url: 'https://www.monex.co.jp/',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.野村證券,
      name: '野村證券',
      url: 'https://hometrade.nomura.co.jp/web/rmfIndexWebAction.do',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.大和証券,
      name: '大和証券',
      url: 'https://www.daiwa.co.jp/PCC/HomeTrade/Account/m8301.html',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.SMBC日興証券,
      name: 'SMBC日興証券',
      url: 'https://www.smbcnikko.co.jp/index.html',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.岡三証券,
      name: '岡三証券',
      url: 'https://www.okasan.co.jp/',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.みずほ証券,
      name: 'みずほ証券',
      url: 'https://www.mizuho-sc.com/index.html?rt_bn=sc_top_hd',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.三菱UFJモルガンスタンレー証券,
      name: '三菱UFJモルガン・スタンレー証券',
      url: 'https://www.sc.mufg.jp/index.html',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds['JIS&T'],
      name: 'JIS&T',
      url: 'https://www.jis-t.ne.jp/dczws000/o3w',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.NRK,
      name: 'NRK',
      url: null,
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
    {
      id: consts.MONOBrokerIds.SBIベネフィットシステムズ,
      name: 'SBIベネフィットシステムズ',
      url: 'https://www.benefit401k.com/',
      link:
        'https://support.minkabu.jp/hc/ja/articles/47680860884889-%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%E8%AA%8D%E8%A8%BC%E3%81%A8%E3%81%AF',
    },
  ] as BrokerListProps[];

  const brokerInfo = brokerList.find(list => list.id === brokerID);

  const refreshAccountInfo = async (): Promise<void> => {
    setIsLoading(true);

    const ret = await syncAccountAsset(account);
    setSyncAccountAssetResponse({
      tag: 'Updated',
      resultCode: ret.ResultCode,
    });

    setIsLoading(false);
  };

  const accountApdateModalClose = () => {
    hide();
    window.location.href = redirectPath;
  };

  const phoneNumberVerificationModalclose = () => {
    hide();
    setIsShowSecondStep(prev => !prev);
  };

  if (brokerInfo === undefined) return <></>;

  if (isLoading) {
    return (
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-row">
            <div className="font-bold text-bluegray-700 text-base">
              しばらくお待ちください
            </div>
            <div className="icon-close ml-auto text-gray-500" />
          </div>
          <div className="my-20 flex justify-center items-center">
            <Loading
              loading={true}
              circularLoading={true}
              style={{
                backgroundColor: 'transparent',
              }}
            />
          </div>
        </div>
      </Modal2>
    );
  }

  if (syncAccountAssetResponse.tag === 'Updated') {
    const resultCode = syncAccountAssetResponse.resultCode;

    return (
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-row">
            {resultCode !== 0 && (
              <div className="icon-alert items-start mr-2 mt-1 text-upcolor"></div>
            )}
            <div className="font-bold text-bluegray-700 text-base">
              {getSyncAccountAssetResultCodeTitle(resultCode)}
            </div>
            <div
              className="icon-close ml-auto text-gray-500"
              onClick={accountApdateModalClose}
            />
          </div>
          <div className="mt-3 text-sm">
            {getSyncAccountAssetResultCodeMessage(resultCode)}
          </div>
        </div>
      </Modal2>
    );
  }

  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto text-sm">
          <div className="flex flex-col">
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={phoneNumberVerificationModalclose}
            />
            <div className="flex flex-row items-baseline">
              <div className="icon-alert items-start mr-2 mt-1 text-upcolor"></div>
              <div className="font-bold text-bluegray-700 text-base">
                口座情報の更新、または電話番号認証を解除してください
              </div>
            </div>
          </div>
          <div className="mt-3">
            連携口座のログイン情報が変更されたか、電話番号認証の設定により口座情報が自動更新されませんでした。
          </div>
          <div className="mt-3">
            次の手順に沿って、口座情報を更新してください。
            <br />
            （エラーコード：003）
          </div>

          <div className="mt-3 font-bold">口座情報更新の手順</div>
          <div className="mt-2 font-bold">
            1. 連携口座のログイン情報を変更した場合
          </div>
          <div className="ml-4 mt-2">
            ログイン情報（ID・パスワードなど）を確認の上、「口座情報の編集」より口座を再連携してください。
          </div>
          <div className="flex">
            <div
              className="ml-auto text-link cursor-pointer"
              onClick={() => doChange()}>
              口座情報の編集
            </div>
          </div>

          <div className="mt-3 font-bold">
            2. 「電話番号認証」を設定している場合
          </div>
          {brokerID === consts.MONOBrokerIds.SBI証券 ? (
            <>
              <div className="ml-4">
                <div className="flex flex-row mt-2">
                  <div>（1）</div>
                  <div className="ml-2">
                    証券会社の公式サイトで「デバイス認証」と「FIDO認証」を両方とも設定してください。
                  </div>
                </div>
                <div className="flex flex-row mt-2">
                  <div>（2）</div>
                  <div className="ml-2">
                    証券会社の公式サイトで「電話番号認証」を解除してください。
                  </div>
                </div>
                <div className="mt-2">
                  ※
                  資産情報を自動更新するには、「電話番号認証」の解除が必要です。
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="ml-4">
                <div className="flex flex-row mt-2">
                  証券会社の公式サイトで「電話番号認証」を解除してください。
                </div>
                <div className="flex flex-row mt-2">
                  ※
                  資産情報を自動更新するには、「電話番号認証」の解除が必要です。
                </div>
              </div>
            </>
          )}
          <div className="mt-2 text-link text-right">
            <a href={brokerInfo.link} target="_blank" rel="noopener noreferrer">
              {brokerID === consts.MONOBrokerIds.SBI証券
                ? 'SBI証券の多要素認証とは'
                : '電話番号認証とは'}
            </a>
          </div>

          {brokerInfo.url && (
            <a href={brokerInfo.url} target="_blank" rel="noopener noreferrer">
              <div className="border rounded-lg border-blue-700 bg-gray-50 flex items-center justify-center py-3 mt-4 shadow">
                <div className="text-blue-700">
                  {brokerInfo.name}の公式サイトへ
                </div>
              </div>
            </a>
          )}
          <div className="mt-4 border-b border-gray-300" />
          {!isShowSecondStep ? (
            <div
              className="flex flex-col items-center mt-6 text-blue-700 cursor-pointer"
              onClick={(): void => setIsShowSecondStep(prev => !prev)}>
              <div className="text-xs">電話番号認証を解除した方は</div>
              <div className="mt-1 text-base font-bold">次のステップへ</div>
              <div className="icon-chevron-down mt-3 transform rotate-0 text-2xl text-bluegray-500 transition duration-300"></div>
            </div>
          ) : (
            <>
              <div className="flex flex-row mt-4 ml-4">
                {brokerID === consts.MONOBrokerIds.SBI証券 ? (
                  <>
                    <div>（3）</div>
                    <div className="ml-2">
                      下記のボタンを押して口座情報を更新してください。
                    </div>
                  </>
                ) : (
                  <>
                    <div>下記のボタンを押して口座情報を更新してください。</div>
                  </>
                )}
              </div>
              <button
                className="mt-4 py-3 text-white bg-bluegray-700 justify-center w-full text-base rounded-lg"
                onClick={refreshAccountInfo}>
                口座情報を更新
              </button>
            </>
          )}
        </div>
      </Modal2>
    </>
  );
};

const UpdateAlignmentAccountModalInternal = ({
  brokerItem,
  isShow,
  isLoading,
  isShowGoMoneytreeSiteDialog,
  hide,
  doChange,
  setIsShowGoMoneytreeSiteDialog,
}: {
  brokerItem: GetUserBrokerResultItem;
  isShow: boolean;
  isLoading: boolean;
  isShowGoMoneytreeSiteDialog: boolean;
  hide: () => void;
  doChange: () => void;
  setIsShowGoMoneytreeSiteDialog: (e: boolean) => void;
}) => {
  const doGoMoneytreeSiteOK = (): void => {
    window.open(
      `${env.moneytreeManagementURL}/connection/${brokerItem?.Account}?client_id=${env.moneytreeClientId}`,
      '_blank'
    );
    setIsShowGoMoneytreeSiteDialog(false);
  };

  return (
    <Modal2 isShow={isShow} close={hide} closeOnClickOutsideWindow>
      {!isLoading ? (
        <div className="p-4">
          <div className="flex flex-row">
            <Icon
              name="alert"
              className="flex items-center h-5 text-red pr-2"
            />
            <div className="text-base font-bold">
              口座情報の編集より、証券会社のID・パスワードを入力してください
            </div>
            <div
              className="icon-close ml-auto text-gray-500 text-2xl"
              onClick={hide}
            />
          </div>
          <div className="mt-4 text-sm">
            <div>
              連携口座のログイン情報が変更された可能性があります。
              <br />
              ログイン情報（ID・パスワードなど）を確認の上、口座情報の更新をお願いします。
            </div>
            <div>(エラーコード：{brokerItem.Status})</div>
            <div
              className="mt-4 text-blue-700 cursor-pointer"
              onClick={doChange}>
              口座情報の編集
            </div>
          </div>
          <div
            onClick={hide}
            className="flex justify-center text-gray-500 mt-4 mb-1 mx-1 p-2 text-base cursor-pointer">
            閉じる
          </div>
        </div>
      ) : (
        <div className="p-4 h-40">
          <div className="absolute top-0 left-0 h-full w-full flex justify-center items-center z-20">
            <Loading
              loading={true}
              circularLoading={true}
              style={{
                backgroundColor: 'transparent',
              }}
            />
          </div>
        </div>
      )}
      {isShowGoMoneytreeSiteDialog && (
        <GoMoneytreeSiteDialog
          onOK={doGoMoneytreeSiteOK}
          onCancel={(): void => setIsShowGoMoneytreeSiteDialog(false)}
        />
      )}
    </Modal2>
  );
};

export const AlignmentAcountLoginInfoChangeModal = ({
  brokerItem,
  redirectPath,
  isShow,
  hide,
}: {
  brokerItem: GetUserBrokerResultItem;
  redirectPath: string;
  isShow: boolean;
  hide: () => void;
}) => {
  const routing = useRouting();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [
    isShowGoMoneytreeSiteDialog,
    setIsShowGoMoneytreeSiteDialog,
  ] = useState<boolean>(false);

  const isPhoneNumberVerificationBroker =
    brokerItem.AggregateSource === consts.AggregateSourceTypes.MONO;
  // テコテックの編集は、MONOの新規登録に遷移させる
  // ただし、並行稼働完了後に破棄
  const doChangeCritter = async (
    brokerItem: GetUserBrokerResultItem
  ): Promise<void> => {
    setIsLoading(true);
    const brokerID = convertToMonoBrokerId(brokerItem.BrokerID);

    const res = await prepareUserBroker({ brokerID });
    if (res.Success) {
      window.location.href = `${env.monoAccountURL}/register-external-integration-sec-account/${brokerID}?onetimeToken=${res.OnetimeToken}&provisionalId=${res.ProvisionalID}&callbackUrl=${env.appURL}/userbrokerlink&returnUri=${window.location.href}`;
    } else if (!res.Success && res.Status === '410') {
    }
  };
  const doChangeMono = async (
    brokerItem: GetUserBrokerResultItem
  ): Promise<void> => {
    setIsLoading(true);

    const res = await prepareUserBroker({
      brokerID: brokerItem.BrokerID,
      account: brokerItem.Account,
    });
    if (res.Success) {
      window.location.href = `${env.monoAccountURL}/register-external-integration-sec-account/${brokerItem.BrokerID}?onetimeToken=${res.OnetimeToken}&monoAccountAggregationId=${brokerItem.Account}&callbackUrl=${env.appURL}/userbrokerlink&returnUri=${window.location.href}`;
    } else if (!res.Success && res.Status === '410') {
    }
  };

  const doChange = (): void => {
    if (!brokerItem) return;

    switch (brokerItem.AggregateSource) {
      case consts.AggregateSourceTypes.テコテック:
        doChangeCritter(brokerItem);
        break;

      case consts.AggregateSourceTypes.MONO:
        doChangeMono(brokerItem);
        break;

      case consts.AggregateSourceTypes.マネーツリー:
        setIsShowGoMoneytreeSiteDialog(true);
        break;

      case consts.AggregateSourceTypes.手入力:
        routing.pushRouting(
          { path: `/optionalassetrenewal/${brokerItem.Account}` },
          true
        );
        break;
    }
  };

  return (
    <>
      {isPhoneNumberVerificationBroker ? (
        <PhoneNumberVerificationBrokerModalInternal
          {...{
            brokerID: brokerItem.BrokerID,
            account: brokerItem.Account,
            redirectPath,
            isShow,
            isLoading,
            setIsLoading,
            hide,
            doChange,
          }}
        />
      ) : (
        <UpdateAlignmentAccountModalInternal
          {...{
            brokerItem,
            isShow,
            isLoading,
            isShowGoMoneytreeSiteDialog,
            hide,
            doChange,
            setIsShowGoMoneytreeSiteDialog,
          }}
        />
      )}
    </>
  );
};
